import styled from 'styled-components';
import {
  tablet_breakpoint,
  desktop_breakpoint,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

export const RecentlyViewedHomesStyles = styled.div`
  .recently-viewed-cards {
    > div {
      margin-bottom: 15px;
    }
  }

  .recently-viewed-heading {
    margin-bottom: 20px;
  }

  .card-heading {
    position: relative;
    top: -5px;
  }

  .cta-card {
    width: 100%;

    .card-info-area {
      > div {
        width: 100%;
      }

      .card-heading {
        position: relative;

        .favorites-cta-text {
          width: 90%;
        }
        .chevron {
          position: absolute;
          right: 0;
          top: 3px;
        }
      }
    }
  }
  @media only screen and (min-width: ${tablet_breakpoint}px) {
  }
  @media only screen and (min-width: ${desktop_breakpoint}px) {
    .recently-viewed-cards {
      display: flex;
      flex-wrap: wrap;

      > div {
        width: 23%;
        margin: 6px;
      }
    }
  }
`;
